import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext({});

const DEFAULTS = {
  logo_url_navbar:   'https://image2url.com/r2/default/images/1775432465627-06dd1d27-a797-457b-9762-e0ec8a726811.png',
  logo_url_footer:   'https://image2url.com/r2/default/images/1775433225118-8a5b704a-de8f-4ced-8bc5-74286adc664f.png',
  logo_width:        '220',
  site_title:        'Lunivus — Where Brands Meet Creators',
  favicon_url:       '',
  stat_creators:     '100+',
  stat_deals:        '10+',
  stat_views:        '80M',
  stat_commission:   '20%',
  stat_retention:    '95%',
  stat_launch:       '3 Days',
  stat_rating:       '4.8★',
  company_name:      'Lunivus',
  company_email:     'hello@lunivus.com',
  company_phone:     '',
  whatsapp_number:   '919310196568',
  commission_rate:   '20',
  trusted_brands:    'Samsung,Zerodha,Garena,Unacademy,CRED,OnePlus,Groww,HealthKart,Loco,AMD',
  trusted_brands_label: 'Trusted by forward-thinking brands',
  hero_title_line1:  'We Connect Brands',
  hero_title_line2:  'with Top Creators',
  hero_subtitle:     'We handle everything from creator matching to campaign execution — on a simple {commission}% commission model. No retainers. No fluff. Just results.',
  hero_cta_primary:  'Start a Campaign',
  hero_cta_secondary:'Browse Creators',
  how_it_works_steps: JSON.stringify([
    { n:'01', t:'Tell Us Your Goal',   d:'Share your brand, audience, and budget. We build a tailored creator strategy.' },
    { n:'02', t:'We Match Creators',   d:'We handpick creators whose audience perfectly aligns with your brand and goals.' },
    { n:'03', t:'We Execute',          d:'Brief, review, publish, and track. Full campaign management from start to finish.' },
    { n:'04', t:'Measure Results',     d:'Full performance report with views, CTR, conversions, and ROI every time.' },
  ]),
  home_services: JSON.stringify([
    { icon:'🎯', title:'Brand Deal Management',  desc:'End-to-end deal handling — creator matching, negotiation, contracts, and delivery.' },
    { icon:'📣', title:'Campaign Execution',      desc:'Multi-creator campaigns from strategy through live tracking and reporting.' },
    { icon:'🎬', title:'Video Production',        desc:'Professional editing, motion graphics, thumbnails, and sponsorship segments.' },
    { icon:'⚡', title:'Short-Form Content',      desc:'High-converting Reels, Shorts, and TikToks that drive real engagement.' },
  ]),
  cta_banner_title:  'Ready to Scale with Creator Marketing?',
  cta_banner_sub:    'Join 10+ brands that have driven measurable growth through Lunivus.',
  cta_btn_primary:   'Start Your Campaign',
  cta_btn_secondary: 'Explore Creators',
  for_brands_why: JSON.stringify([
    { icon:'🔗', t:'Curated Creator Network',    d:'Access hand-vetted creators — YouTube creators with millions of subscribers and Instagram influencers with high engagement rates — across every major niche.' },
    { icon:'💸', t:'Commission-Only Model',      d:'We take a flat commission only when we close a deal. No upfront retainers, no hidden fees. Our success is 100% tied to yours.' },
    { icon:'⚡', t:'Fast Campaign Launch',       d:'From brief to live campaign quickly. We have established relationships that eliminate weeks of back-and-forth.' },
    { icon:'📊', t:'Full ROI Reporting',         d:'Detailed post-campaign reports with views, engagement, click-throughs, conversions, and ROI. You always know what you got.' },
    { icon:'🛡', t:'Brand Safety Guaranteed',    d:'Every creator is audited for fake followers, brand safety, past content quality, and audience demographics before we recommend them.' },
    { icon:'🤝', t:'Dedicated Account Manager', d:'One person who knows your brand, goals, and preferences — from first brief to final report, you have a single point of contact.' },
  ]),
  for_brands_steps: JSON.stringify([
    { n:'01', t:'Discovery Call',     d:"We learn your brand, campaign goals, target audience, and budget. This is free and takes 30 minutes." },
    { n:'02', t:'Creator Shortlist',  d:'Within 48 hours we send you a curated shortlist of 3–5 creators with full analytics and rate cards.' },
    { n:'03', t:'Deal Negotiation',   d:'You approve the creator. We handle all outreach, rate negotiation, contracts, and content briefs.' },
    { n:'04', t:'Content Review',     d:'We manage the content creation process, review for brand alignment, and get your sign-off before anything goes live.' },
    { n:'05', t:'Campaign Goes Live', d:'Content publishes. We monitor performance in real-time and flag any issues immediately.' },
    { n:'06', t:'Results & Scale',    d:'Full campaign report delivered. We identify top performers and recommend scaling what worked.' },
  ]),
  about_mission_p1:  'We saw a massive gap in the influencer marketing space. Brands were wasting budgets on the wrong creators. Creators were missing out on deals they were perfect for. Agencies were overcharging for underdelivering.',
  about_mission_p2:  "So we built Lunivus — a deal-focused studio that connects brands to the right creators with surgical precision. We don't do full management. We do one thing exceptionally: brand deals that deliver measurable results.",
  about_mission_p3:  "Our model is simple. We take {commission}% commission on every deal we close. No upfront fees. No retainers. If we don't deliver, we don't earn.",
  about_values: JSON.stringify([
    { icon:'🎯', t:'Results-First',   d:'We measure every campaign by real outcomes — views, sign-ups, sales. Vanity metrics are not our business.' },
    { icon:'🤝', t:'Alignment',       d:"Our commission model means we only win when you win. That keeps us fully aligned with your success." },
    { icon:'🔍', t:'Transparency',    d:"No black-box pricing. No surprise fees. We show you exactly what you're paying for and what you're getting." },
    { icon:'🛡', t:'Trust & Safety',  d:'Every creator is vetted. Every deal is contractual. Every campaign is managed with brand safety as the top priority.' },
  ]),
  contact_eyebrow:               'Get In Touch',
  contact_hero_title:            "Let's Work Together",
  contact_hero_sub:              "Whether you're a brand ready to launch a campaign or a creator looking to join our network — we'd love to hear from you.",
  contact_brand_form_title:      'Start a Campaign',
  contact_brand_form_sub:        "Tell us about your brand and goals. We'll match you with the perfect creators.",
  contact_creator_form_title:    'Apply to Join Our Network',
  contact_brand_success_title:   "We've Got Your Brief!",
  contact_creator_success_title: 'Application Received!',
  contact_sidebar_title:         'Get In Touch',
  contact_response_time:         'Within 24 hours',
  contact_why_title:             'Why LUNIVUS?',
  join_eyebrow:            'For Creators',
  join_hero_title:         'Join Our Creator Network',
  join_hero_sub:           'We connect vetted YouTube Creators and Instagram Influencers with premium brand deals.',
  join_why_eyebrow:        'Why Join?',
  join_why_title:          'We Work For You',
  join_requirements_title: 'Creator Requirements',
  join_req_general:        'Brand-safe content history & professional attitude',
  join_form_title:         'Apply to Join',
  join_form_sub:           'Takes 3 minutes. We review within 48 hours.',
  join_form_note:          'We review all applications within 48 hours',
  join_submit_btn:         'Submit Application →',
  join_success_title:      'Application Submitted!',
  join_success_sub:        "Our team will review your profile within 48 hours and reach out if you're a great fit.",
  join_yt_requirements:    JSON.stringify(['Minimum 20K subscribers','Consistent upload schedule (2+ videos/month)','Genuine engaged audience']),
  join_ig_requirements:    JSON.stringify(['Minimum 20K followers','Regular posting schedule','High avg views (>2%)']),
  join_benefits: JSON.stringify([
    { icon:'💼', t:'More Brand Deals',   d:'We bring brand opportunities directly to you.' },
    { icon:'💰', t:'Better Rates',       d:'Our team negotiates hard on your behalf.' },
    { icon:'🤝', t:'Brand Partnerships', d:'Only brands that align with your content and audience.' },
    { icon:'📈', t:'Career Growth',      d:'Join creators already earning through us.' },
  ]),
  footer_tagline:        'A creator deal agency connecting brands with top YouTube creators. We handle the deals — you own the growth.',
  footer_cta_text:       'Start a Campaign →',
  footer_contact_title:  'Get In Touch',
  footer_connect_title:  'Connect',
  footer_copyright_year: String(new Date().getFullYear()),
  footer_rights_text:    'All rights reserved.',
  footer_trust_badges:   JSON.stringify(['🔒 Brand Safe','✅ Verified Creators','📊 Data Driven']),
  footer_social_links:   JSON.stringify([
    { label:'LinkedIn',    url:'#' },
    { label:'Instagram',   url:'#' },
    { label:'Twitter / X', url:'#' },
    { label:'YouTube',     url:'#' },
  ]),
  nav_cta_text:       'Start a Campaign',
  nav_creator_btn:    'Join as Creator',
  nav_label_cases:    'Case Studies',
  nav_label_services: 'Services',
  nav_label_brands:   'For Brands',
  nav_label_about:    'About',
};

// Module-level cache — persists across component mounts within the same session
let _cache = null;
let _cacheTime = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

function updateFavicon(url) {
  if (!url) return;
  let link = document.querySelector("link[rel~='icon']");
  if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
  link.href = url;
}

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => _cache ? { ...DEFAULTS, ..._cache } : DEFAULTS);
  const [loaded,   setLoaded]   = useState(!!_cache);

  useEffect(() => {
    const now = Date.now();
    // Use cache if fresh
    if (_cache && (now - _cacheTime) < CACHE_TTL) {
      setSettings({ ...DEFAULTS, ..._cache });
      setLoaded(true);
      return;
    }

    axios.get('/api/settings')
      .then(r => {
        if (r.data?.data) {
          _cache     = r.data.data;
          _cacheTime = Date.now();
          const merged = { ...DEFAULTS, ..._cache };
          setSettings(merged);
          if (merged.site_title)  document.title = merged.site_title;
          if (merged.favicon_url) updateFavicon(merged.favicon_url);
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loaded }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);
